document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }
  // Note: contact form submission is now handled natively by Shopify's
  // {% form 'contact' %} tag (posts to /contact) — no JS interception needed.
});
